import { createStore } from '@aibees/shared/store';
import { SearchPersonStoreData as StoreData } from './types';

const useSearchPersonStore = createStore<StoreData>(
  'search-person',
  (set, get) => ({
    id: undefined,
    setId: (id) => set({ id }),

    peopleSearchItems: [],
    setPeopleSearchItems: (peopleSearchItems) => {
      if (typeof peopleSearchItems === 'function') {
        const currentItems = get().peopleSearchItems;
        const newItems = peopleSearchItems(currentItems);
        set({ peopleSearchItems: newItems });
      } else {
        set({ peopleSearchItems });
      }
    },

    lookalikeIds: [],
    setLookalikeIds: (ids) => set({ lookalikeIds: ids }),
  })
);

export default useSearchPersonStore;
